import { useTranslation } from "react-i18next";

import SyncButton from "./SyncButton";

import { Label } from "@/components/ui/v2/label";
import { Switch } from "@/components/ui/v2/switch";
import { TableToolbar } from "@/components/ui/v2/table/table-toolbar";
import { usePermissionMatrix } from "@/lib/hooks/usePermissionMatrix";
import { ClientType } from "@/types/client/ClientType";

type VacanciesTableToolbarProps = {
  clientId?: string;
  onSearchChange: (value: string) => void;
  onFiltersClick: () => void;
  showUnpublished: boolean;
  onShowUnpublishedChange: (checked: boolean) => void;
  client?: ClientType;
  searchValue?: string;
};

export function VacanciesTableToolbar({
  clientId,
  onSearchChange,
  onFiltersClick,
  showUnpublished,
  onShowUnpublishedChange,
  client,
  searchValue,
}: VacanciesTableToolbarProps) {
  const { t } = useTranslation();
  const { canEdit } = usePermissionMatrix();
  
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2 justify-between">
        <TableToolbar
          onSearchChange={onSearchChange}
          onFiltersClick={onFiltersClick}
          searchValue={searchValue}
        />
        {canEdit("vacancies") && client?.clientType === "ATS" && clientId ? (
          <SyncButton clientId={clientId} />
        ) : undefined}
      </div>
      <div className="flex items-center gap-2">
        <Switch
          id="show-unpublished"
          checked={showUnpublished}
          onCheckedChange={onShowUnpublishedChange}
        />
        <Label htmlFor="show-unpublished" className="cursor-pointer">
          {t("common.showunpublished")}
        </Label>
      </div>
    </div>
  );
}
